import type { CreatureSkillEntryResolutionInput, HydratedCreatureSkillEntry } from '../types';
import { hydrateCreatureSkillEntry } from '../compile/creature-skill-entry-hydration';

/** Resolve a stored or elided-default skill through the canonical/legacy bucket bridge. */
export function resolveCreatureSkillEntry(input: CreatureSkillEntryResolutionInput): HydratedCreatureSkillEntry | null {
    const skills = input.canonicalSkills ?? input.legacySkills ?? {};
    const entry = Object.prototype.hasOwnProperty.call(skills, input.variableName) ? skills[input.variableName] ?? null : null;
    if (entry !== null && typeof entry === 'object') {
        return hydrateCreatureSkillEntry({ ...entry } as Readonly<Record<string, unknown>>, input.variableName, input.registry);
    }
    if (entry === null && Object.keys(skills).length > 0) {
        const definition = Object.prototype.hasOwnProperty.call(input.registry.byVariable, input.variableName)
            ? input.registry.byVariable[input.variableName] : undefined;
        if (definition) {
            const defensive = definition.item_type === 'defensive_skill' || definition.item_type === 'innate_skill';
            return hydrateCreatureSkillEntry({
                tier_level: defensive ? 1 : 0,
                sources: [defensive ? 'default_defensive' : 'default_flawed'],
            }, input.variableName, input.registry);
        }
    }
    return null;
}
